import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SellerLogin from './pages/SellerLogin';
import SellerDashboard from './pages/SellerDashboard';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  // VIKTIG FIKS: Tillat alle salgs-relaterte roller, ikke bare 'seller'
  const allowedRoles = ['seller', 'sales_chief', 'team_leader'];
  
  if (!isAuthenticated || !allowedRoles.includes(user?.role)) {
    return <Navigate to="/seller/login" />;
  }
  return children;
};

const SellerModule = () => {
  return (
    <Routes>
      <Route path="login" element={<SellerLogin />} />
      <Route path="dashboard" element={
        <ProtectedRoute>
          <SellerDashboard />
        </ProtectedRoute>
      } />
      <Route path="/" element={<Navigate to="login" />} />
    </Routes>
  );
};

export default SellerModule;